import { useAxios } from "@hooks";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { App } from "antd";
import { useTranslation } from "react-i18next";

export const useExamGroupReorder = (examId?: string, examPeriodScreen?: boolean) => {

    const axios = useAxios();
    const {t} = useTranslation();
    const queryClient = useQueryClient();
    const {message} = App.useApp();

    const reorder = async (examGroup: any) => {
        try {
            if (!examPeriodScreen) {
                const response = await axios.put(`/api/examgroup/reorder/${examId}`, examGroup);
                return response.data;
            } else {
                const response = await axios.put(`/api/ExamTerms/reorder/${examId}`, examGroup);
                return response.data;
            }
           
        } catch (error) {
            throw new Error(t("messages.error.examGroupReorder"));
        }
    }

    return useMutation({mutationFn: reorder, 
        onSuccess: () => {
            queryClient.invalidateQueries({queryKey: ["examGroups"]});
            message.success(t("messages.success.examGroupReorder"));
        }
    });
}